import MyLoader from '@/components/MyLoader';

const QuizCardLoading = ({ isImageLoading, children }) => {
    return (
        <div className="quizzes-body-image-loading-container">
            {isImageLoading && (
                <div className="quizzes-body-image-loading">
                    <MyLoader color={'red'} />
                </div>
            )}
            {children}
        </div>
    );
};

export default QuizCardLoading;
